import { BrowserRouter, Route, Routes } from "react-router-dom";

import { TicketGenerate } from "./Components/ticketgenerate/TicketGenerate";
import { TicketGenerateRest } from "./Components/ticketgenerate/RestuTicket";



function App() {
  return (
    <>
    <BrowserRouter>
      <Routes>
        
        <Route path='/' element={<TicketGenerate/>}/>
        <Route path='/restaurant-ticket' element={<TicketGenerateRest/>}/>
    
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
